<!-- src/app/layout/topbar/topbar.component.html -->
<header class="topbar">

    <!-- Hamburger (solo mobile) -->
    <button class="menu-btn" (click)="menuToggle.emit()" title="Menú">
        <i class="pi pi-bars"></i>
    </button>

    <!-- Título de la página -->
    <div class="topbar-center">
        <h1 class="page-title">{{ pageTitle() }}</h1>
    </div>

    <!-- Acciones -->
    <div class="topbar-actions">

        <!-- Jornada: iniciar / finalizar (TECNICO / SUPERVISOR) -->
        @if (sessionState.canStart()) {
        <button class="action-btn start-session-btn" (click)="sessionState.requestStart()"
            title="Iniciar jornada">
            <i class="pi pi-play-circle"></i>
            <span class="session-label">Iniciar jornada</span>
        </button>
        }
        @if (sessionState.canEnd()) {
        <button class="action-btn end-session-btn" (click)="sessionState.openEndDialog()"
            title="Finalizar jornada">
            <i class="pi pi-stop-circle"></i>
            <span class="session-label">Finalizar jornada</span>
        </button>
        }

        <!-- Toggle dark / light -->
        <button class="action-btn theme-btn" (click)="theme.toggle()"
            [title]="theme.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
            @if (theme.isDark()) {
            <i class="pi pi-sun"></i>
            } @else {
            <i class="pi pi-moon"></i>
            }
        </button>

        <!-- Notificaciones -->
        <button class="action-btn" title="Notificaciones">
            <i class="pi pi-bell"></i>
            <span class="notif-dot"></span>
        </button>

        <!-- Avatar usuario -->
        <button class="user-pill" (click)="openProfile()" title="Mi Perfil">
            <div class="avatar">{{ auth.fullName().charAt(0) }}</div>
            <div class="user-details desktop-only">
                <span class="name">{{ auth.fullName() }}</span>
                <span class="role">{{ auth.role() }}</span>
            </div>
        </button>

    </div>
</header>

<app-profile [visible]="profileVisible()" (close)="closeProfile()" />